<template>
  <div class="animated fadeIn">
    <loader :show="enviando"/>
    <b-row>
      <b-col sm="12" md="12">
        <b-card header-tag="header" >
          <div slot="header">
            <strong> Usuarios</strong>
          </div>
          <b-row>
            <b-col 
              v-if="puedeAgregar"
              md="12" class="text-center">
              <b-button 
                size="sm" 
                variant="primary"
                @click="agregarUsuario()">
                Nuevo usuario
              </b-button>
            </b-col>
            <b-col md="12">
              
              <v-client-table 
                    :columns="tabla.columns" 
                    :data="tabla.data" 
                    :options="tabla.options">
                    <div v-if="puedeVerUsuario || puedeCambiarPass"
                      slot="options" slot-scope="props">
                      <b-dropdown 
                        id="ddown1" 
                        size="sm" 
                        variant="outline-primary" 
                        text="Opciones">
                        <b-dropdown-item v-if="puedeVerUsuario" @click="verUsuario(props.row._id)">Información de usuario</b-dropdown-item>
                        <b-dropdown-item v-if="puedeCambiarPass" @click="resetPassword(props.row._id)">Restablecer contraseña</b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </v-client-table>

            </b-col>
            <b-col md="6" class="text-right">
              <b-button 
                size="sm" 
                variant="primary"
                @click="agregarUsuario()">
                Nuevo usuario
              </b-button>
            </b-col>
            <b-col v-if="puedeXLSX"
              md="6" class="text-right">
              <b-button 
                size="sm" 
                variant="success"
                @click="generaXLSX()">
                Generar Excel
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row><!--/.row-->
  </div>
</template>

<script>

import swal from 'sweetalert'
import axios from 'axios'
import Loader from '../Loader'
import { mapGetters } from "vuex";

export default {
  name: 'usuarios',
  components: {
    Loader
  },
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role"
    ]),
    puedeAgregar(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 101) >= 0 )
        return true;
      else
        return false;
    },
    puedeXLSX(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 107) >= 0 )
        return true;
      else
        return false;
    },
    puedeVerUsuario(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 102) >= 0 )
        return true;
      else
        return false;
    },
    puedeCambiarPass(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 104) >= 0 )
        return true;
      else
        return false;
    },
  },
  data: function () {
    return {
      titulo: this.$route.name,
      enviando: false,
      tabla: {
        data: [],
        columns: ['options','codigo','paterno','materno','nombre','dependencia'],
        options: {
          headings: {
            options: '',
            codigo: 'Código',
            paterno: 'Paterno',
            materno: 'Materno',
            nombre: 'Nombre',
            dependencia: 'Dependencia'
          },
          sortable: ['codigo', 'materno', 'paterno', 'nombre','dependencia'],
          filterable: ['codigo', 'materno', 'paterno', 'nombre','dependencia'],
          perPage: 50,
          perPageValues: [10, 20, 30, 50, 100],
          sortIcon: {
                base: 'fa',
                up: 'fa-sort-amount-asc',
                down: 'fa-sort-amount-desc',
                is: 'fa-sort'
            },
          texts: {
                count: "Mostrando del {from} al {to} de {count} registros|{count} registros|Único registro",
                first: 'Primero',
                last: 'Último',
                filter: "Buscar:",
                filterPlaceholder: "Ingrese...",
                limit: "Registros:",
                page: "Página:",
                noResults: "No hay registros.",
                filterBy: "Filtrando por {column}",
                loading: 'Cargando...',
                defaultOption: 'Select {column}',
                columns: 'Columns'
            }
        }
      }
    }
  },
  created(){ //Se obtienen los usuarios
      if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero === 100) < 0)
        this.$router.go(-1);
      this.enviando = true;
      //console.log(this.permisos);
      axios.get(this.httpURL+'/usuarios',{headers:{token:this.sessionToken}})
              .then(res => {
                  //console.log(res.data);
                  for( let i=0; i<res.data.usuarios.length; i++ ){
                    let item = {};
                    let element = res.data.usuarios[i];
                    item.options = "";
                    item._id = element._id;
                    item.numero = i+1;
                    item.codigo = element.codigo;
                    item.nombre = element.nombre;
                    item.paterno = element.paterno;
                    item.materno = element.materno;
                    item.dependencia = '';
                    this.tabla.data.push(item);
                  }
                  this.enviando = false;
              })
              .catch(error => {
                  if(error.response){
                      swal("Oops!",error.response.data.mensaje , "error")
                      if( error.response.status === 403 )
                        this.$router.go(-1);
                  }else if( error.request){
                      swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
                  }
                  this.enviando = false;
              });
  },
  methods: {
    agregarUsuario(){
      this.$router.push('usuarios/nuevo');
    },
    verUsuario(id){
      this.$router.push('usuarios/'+id);
    },
    modificarUsuario(){
      swal('Modificar');
    },
    generaXLSX(){
        this.enviando = true;
        axios.get(this.httpURL+'/usuarios/xlsx',
            {headers:{token:this.sessionToken},responseType: 'blob'})
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'listado_usuarios.xlsx');
                document.body.appendChild(link);
                link.click();
                this.enviando = false;
                })
            .catch(error => {
                //console.log(error);
                this.enviando = false;
                if(error.response){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                            text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:1500, speed: 1000,
                            text: 'No se pudo establecer una conexión al servidor.' });
                }
            });
    },
    resetPassword(id){
      swal({
      icon: 'info',
      title: 'Área protegida',
      text: 'Esta acción requiere de tu contraseña:',
      content: {
        element: "input",
        attributes: {
        placeholder: "Ingrese...",
        type: "password",
        }
      },
      closeOnClickOutside: true,
      button: {
        text: "Confirmar",
        closeModal: false,
      },
    })
    .then(password => {
      if (!password){
        swal.close();
      }else{
        axios.put(this.httpURL+'/usuarios/resetPassword/'+id,
              {password},
              {headers: {token:this.sessionToken}})
          .then(res => {
              swal.stopLoading();
              swal.close();
              swal(res.data.mensaje);
              //console.log(res);
          })
          .catch(error => {
              //console.log(error);
              swal("Error",'Contraseña incorrecta', "error");
          });
      }
    });
    }
  }
}
</script>

<style >
  
</style>
